import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import './styles.css';
import ButtonDefault from "../../components/ButtonDefault";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { NoGoalsCard } from "../../components/NoGoalsCard";
import { useDispatch, useSelector } from "react-redux";
import { GoalsWrapper } from "../GoalsWrapper";
import NewAcademyGoalPopper from "../NewAcademyGoalPopper";
import GoalDetails from "../GoalDetails";
import { createGoal, getGoals, updateGoal } from "../../api/goals";
import { setGoals } from "../../redux/reducers/goalsAndStrategy";
import { GoalCardSkeleton } from "../../components/GoalCardSkeleton";

export const AcademyGoals = () => {
    const [t] = useTranslation();
    const goals = useSelector((state:any) => state.goalsAndStrategy.goals);
    const [filteredGoals, setFilteredGoals]:any = useState(goals);
    const [isAddNewGoal, setIsAddNewGoal] = useState(false);
    const [isFetchingGoals, setIsFetchingGoals] = useState(false);
    const currentClub = useSelector((state:any) => state.clubDetails);
    const selectedDepartments = useSelector((state:any) => state.common.departmentsFilter);
    const dispatch = useDispatch();
    const goalsSearchString = useSelector((state: any) => state.common.goalsSearchString);
    const selectedClubs = useSelector((state:any) => state.common.clubNameFilter);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);

    const fetchGoals = async () => {
        !goals && setIsFetchingGoals(true);
        const response = await getGoals(!isAdmin && { clubId: currentClub?.id });
        dispatch(setGoals(response));
        setFilteredGoals(response);
        !goals && setIsFetchingGoals(false);
    }  

    useEffect(() => {
        !isFetchingGoals && !goals &&
        fetchGoals(); 
    }, [goals, currentClub, updateGoal]);

    useEffect(() => {
        if((selectedDepartments && selectedDepartments.length > 0) ||
         (selectedClubs && selectedClubs.length > 0) ||
         (goalsSearchString != '' && goalsSearchString != null)) {
            const selectedDeptIds = selectedDepartments?.map((dept:any) => dept.id);
            const selectedClubIds = selectedClubs?.map((club:any) => club.id);
            const tempArr = goals.filter((goal:any) => 
                selectedDeptIds?.includes(goal.departmentId) ||
                (isAdmin && selectedClubIds?.includes(goal.clubId)) ||
                (goalsSearchString !== '' && goalsSearchString != null && goal?.name?.toLowerCase()?.includes(goalsSearchString?.toLowerCase())) ||
                (goalsSearchString !== '' && goalsSearchString != null && goal?.description?.toLowerCase()?.includes(goalsSearchString?.toLowerCase())) ||
                (goalsSearchString !== '' && goalsSearchString != null && goal?.ownerName?.toLowerCase()?.includes(goalsSearchString?.toLowerCase())) ||
                (goalsSearchString !== '' && goalsSearchString != null && goal?.departmentName?.toLowerCase()?.includes(goalsSearchString?.toLowerCase()))
            );
            setFilteredGoals(tempArr);
        } else {
            setFilteredGoals(goals);
        }
    }, [selectedDepartments, goalsSearchString, selectedClubs])

    return(
        <Box className={'academyGoalsWrapper'}>
            <NewAcademyGoalPopper isOpen={isAddNewGoal} handleClickAway={() => {setIsAddNewGoal(false)}}/>
            <Typography className="fs18 fw800 uppercase">
                {`${t('ACADEMY')} ${t('GOALS')}`}
            </Typography>
            <Box sx={{ mt: '10px' }}>
                {
                    !isFetchingGoals &&
                    <ButtonDefault 
                    value={t('ADD_GOAL')}
                    icon={<FontAwesomeIcon width={'12px'} icon={faPlus}/>}
                    manageOnClick={() => {setIsAddNewGoal(true)}}
                    />
                }
            </Box>
            <Box sx={{ mt: '10px', width: '98%', height: '100%' }}>
                {
                    !isFetchingGoals && goals && goals?.length > 0 && filteredGoals && filteredGoals?.length > 0 ?
                    <GoalsWrapper data={filteredGoals} isLoading={isFetchingGoals} /> :
                    (
                        isFetchingGoals ?
                        [...Array(2)].map(() => {
                           return <GoalCardSkeleton />
                        }):
                        <NoGoalsCard />
                    )
                }
            </Box>
        </Box>
    )
}